
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/[book]/[chapter]",
      function () {
        return require("private-next-pages/books/[book]/[chapter]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/[book]/[chapter]"])
      });
    }
  